import { AI_INSIGHTS, VALUATION_INSIGHTS } from '../constants/config';
import * as React from 'react';
import InsightsIcon from '../components/automated-insights/icons/InsightsOutlined';

export const HOME_TABS = {
    OVERVIEW: {
        name: 'OVERVIEW',
        titleKey: 'tabs.overview',
        permission: null,
        dataTest: 'overview-tab',
        icon: props => (
            <i className="fa-regular fa-square-poll-vertical" {...props} />
        ),
    },
    AI_INSIGHTS: {
        name: 'AI_INSIGHTS',
        titleKey: 'tabs.automatedInsights',
        permission: AI_INSIGHTS,
        dataTest: 'ai-insights-tab',
        icon: props => <InsightsIcon width={16} height={16} {...props} />,
    },
    VALUATION_INSIGHTS: {
        name: 'VALUATION_INSIGHTS',
        titleKey: 'tabs.valuationInsights',
        permission: VALUATION_INSIGHTS,
        dataTest: 'valuation-insights-tab',
        icon: props => (
            <i className="fa-regular fa-square-poll-vertical" {...props} />
        ),
    },
};
